import { getCoreApiGatewayKeysSlice } from './get';
import { postApiGatewayKeys } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreApiGatewayKeysSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [
			getCoreApiGatewayKeysSlice.asyncActionCreators.repeatGetCoreApiGatewayKeys
		]
	},
	name: 'CoreApiGatewayKeys',
	receive: false,
	request: true,
	requestHandler: postApiGatewayKeys,
	yieldType: SagaYieldType.Latest
});

